import { Tooltip, Link, Checkbox } from "@mui/material";
import { round } from "lodash";
import {
  multiplierOptions,
  getFileNameFromUrl,
  multiplierMappings,
} from "../../../utils";
import NumericLabel from "../../../components/NumericLabel";
import { NOTE_TYPES } from "../../../store/notesSlice";
import CustomEditComponent from "./CustomEditComponent";
import config from "../../../config";

export const getPlanogramColumns = (
  processCallback,
  plannerNotes = [],
  retailerNotes = []
) => [
  {
    field: "fl_dept_name",
    headerName: "Department",
    sortable: false,
    width: 160,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_class_name",
    headerName: "Category",
    width: 160,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_sub_name",
    headerName: "Planogram",
    width: 160,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "planogram",
    headerName: "Planogram #",
    width: 130,
    renderCell: (params) => (
      <Tooltip title={params.value ? getFileNameFromUrl(params.value) : ""}>
        <Link
          href={config.PogFileBasePath.concat(params.value)}
          target="_blank"
          rel="noreferrer noopener"
        >
          {getFileNameFromUrl(params.value)}
        </Link>
      </Tooltip>
    ),
  },
  {
    field: "core",
    headerName: "Core",
    sortable: false,
    width: 60,
  },
  {
    field: "footage",
    headerName: "Footage",
    width: 80,
  },
  {
    field: "pogsku",
    headerName: "POG SKUs",
    width: 100,
    renderCell: (params) =>
      !!params?.value ? (
        <NumericLabel isSeparator value={round(params?.value, 2)} />
      ) : (
        ""
      ),
  },
  {
    field: "pogqty",
    headerName: "POG Qty",
    width: 80,
    renderCell: (params) =>
      !!params?.value ? (
        <NumericLabel isSeparator value={round(params?.value, 2)} />
      ) : (
        ""
      ),
  },
  {
    field: "pogcost",
    headerName: "POG Cost",
    width: 90,
    renderCell: (params) =>
      !!params?.value ? (
        <NumericLabel isSeparator value={round(params?.value, 2)} />
      ) : (
        ""
      ),
  },
  {
    field: "missingskus",
    headerName: "Missing SKUs",
    sortable: false,
    width: 110,
    renderCell: (params) =>
      !!params?.value ? (
        <NumericLabel isSeparator value={round(params?.value, 2)} />
      ) : (
        ""
      ),
  },
  {
    field: "multiplier",
    headerName: "Multiplier",
    sortable: false,
    width: 85,
    renderCell: (params) => {
      return params?.value ? multiplierMappings[params.value] : "";
    },
    renderEditCell: (params) => (
      <CustomEditComponent
        {...params}
        getProcessedRow={processCallback}
        fieldType="multiplier"
        default=""
        options={multiplierOptions}
      />
    ),
    editable: true,
  },
  {
    field: "adjqty",
    headerName: "Adj. Qty",
    width: 80,
    renderCell: (params) =>
      !!params?.value ? (
        <NumericLabel isSeparator value={round(params?.value, 2)} />
      ) : (
        ""
      ),
  },
  {
    field: "adjcost",
    headerName: "Adj. Cost",
    width: 80,
    renderCell: (params) =>
      !!params?.value ? (
        <NumericLabel isSeparator value={round(params?.value, 2)} />
      ) : (
        ""
      ),
  },
  {
    field: "PlannerAction",
    headerName: "Status",
    type: "boolean",
    width: 70,
    renderCell: (params) => {
      return (
        <Checkbox
          readOnly
          checked={Boolean(params.value)}
          disabled={!params.row.plannernotesid}
          sx={{ width: "auto", padding: "0rem" }}
        />
      );
    },
    renderEditCell: (params) => (
      <CustomEditComponent
        {...params}
        getProcessedRow={processCallback}
        fieldType="checkbox"
        disabled={!params.row.plannernotesid}
      />
    ),
    editable: true,
  },
  {
    field: "plannernotesid",
    headerName: "Planner Notes",
    sortable: false,
    width: 200,
    renderCell: (params) => {
      let currentValue = plannerNotes.find((note) => note?.id === params.value);
      currentValue = !!currentValue ? currentValue?.Notes : "";
      return (
        <Tooltip title={currentValue ? currentValue : ""}>
          <span>{currentValue}</span>
        </Tooltip>
      );
    },
    renderEditCell: (params) => (
      <CustomEditComponent
        {...params}
        getProcessedRow={processCallback}
        fieldType="autoComplete"
        noteType={NOTE_TYPES[0]}
        options={plannerNotes}
      />
    ),
    editable: true,
  },
  {
    field: "RetailerAction",
    headerName: "Status",
    type: "boolean",
    width: 70,
    renderCell: (params) => {
      return (
        <Checkbox
          readOnly
          checked={Boolean(params.value)}
          disabled={!params.row.retailernotesid}
          sx={{ width: "auto", padding: "0rem" }}
        />
      );
    },
    renderEditCell: (params) => (
      <CustomEditComponent
        {...params}
        getProcessedRow={processCallback}
        fieldType="checkbox"
        disabled={!params.row.retailernotesid}
      />
    ),
    editable: true,
  },
  {
    field: "retailernotesid",
    headerName: "Retailer Notes",
    sortable: false,
    width: 200,
    renderCell: (params) => {
      let currentValue = retailerNotes.find(
        (note) => note?.id === params.value
      );
      currentValue = !!currentValue ? currentValue?.Notes : "";
      return (
        <Tooltip title={currentValue ? currentValue : ""}>
          <span>{currentValue}</span>
        </Tooltip>
      );
    },
    renderEditCell: (params) => (
      <CustomEditComponent
        {...params}
        getProcessedRow={processCallback}
        fieldType="autoComplete"
        options={retailerNotes}
        noteType={NOTE_TYPES[1]}
      />
    ),
    editable: true,
  },
];
